import request from '@/utils/request';
import qs from 'qs';

const SERVER_URL = process.env.VUE_APP_SERVER_URL;
const version = isQQBrowser();

let config = {};
let timeout = '';

export async function pay(opts, fun) {
  config = {
    paySuccess: () => {
      console.log('支付成功');
    },
    payError: () => {
      console.log('支付失败');
    },
    launchSuccess: () => {
      console.log('发起成功');
    },
    launchError: () => {
      console.log('发起失败');
    },
    ...fun,
  };
  console.log(config);

  // 检测支付类型
  if (opts.payType === 'WX') {
    // 检测微信支付细分类型（公众号/H5）
    if (version) {
      if (parseInt(version) >= 5) {
        opts.payStyle = 'JSAPI';
      } else {
        alert('微信版本过低，无法完成支付，请升级后重试！');
        return;
      }
    } else {
      opts.payStyle = 'H5';
    }
  } else if (opts.payType === 'ALI') {
    opts.payStyle = 'WAP';
    if (version) {
      window.location.assign(window.location.origin + '/h5-activity/pay/#/alipay' + setSearch(opts));
      return;
    }
  } else if (opts.payType === 'paypal') {
    opts.payType = 'PAY_PAL';
  } else if (opts.payType === 'unionpay') {
    opts.payType = 'UNION';
  }

  const res = await getPayPage(opts);
  console.log('getPayPage', res);
  if (res.success) {
    // 第三方支付接入
    payOrder(res.data, opts);
    // 支付状态检测
    loopPayStatus(res.data.payrecordId, () => {
      clearTimeout(timeout);
    });
  } else {
    if (res.message && res.message.includes('已成功购买')) {
      config.launchSuccess(res);
      loopPayStatus(res.data.payrecordId, () => {
        clearTimeout(timeout);
      });
    } else {
      config.launchError(res);
    }
  }
}

// 获取支付页面
async function getPayPage(opt) {
  return await request.post(`${SERVER_URL}/goodsOrder/getPayPage`, qs.stringify(opt), {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  });
}

async function payOrder(data, opts) {
  // 支付宝支付
  if (opts.payType === 'ALI') {
    const form = data.payPage;
    const div = document.createElement('div');
    div.innerHTML = form;
    document.body.appendChild(div);
    document.forms[0].submit();
  } else if (opts.payType === 'UNION') {
    // 银联支付
    const div = document.createElement('div');
    let formHtml = `<form id="UNIONFORM" name="punchout_form" style="display: none;" method="post" action="${data.payPage}">`;
    for (let key in data.unionPayData) {
      formHtml += `<input name="${key}" value="${data.unionPayData[key]}" />`;
    }
    formHtml += '</form>';
    div.innerHTML = formHtml;
    document.body.appendChild(div);
    document.getElementById('UNIONFORM').submit();
  } else if (opts.payType === 'PAY_PAL') {
    // PayPal支付
    window.location.assign(data.payPage);
  } else if (opts.payStyle === 'H5') {
    config.payError({ msg: '暂不支持非微信环境进行微信支付' });
  } else if (opts.payStyle === 'JSAPI') {
    // 微信公众号支付
    // eslint-disable-next-line no-inner-declarations
    function onBridgeReady() {
      // eslint-disable-next-line no-undef
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        {
          appId: data.appId, //公众号名称，由商户传入
          timeStamp: data.timeStamp, //时间戳，自1970年以来的秒数
          nonceStr: data.nonceStr, //随机串
          package: data.package,
          signType: data.signType, //微信签名方式：
          paySign: data.paySign, //微信签名
        },
        function (res) {
          if (res.err_msg === 'get_brand_wcpay_request:ok') {
            // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
          } else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
            // 支付过程中用户取消
            config.payError({ msg: '用户取消支付' });
          } else if (res.err_msg === 'get_brand_wcpay_request:fail') {
            // 支付失败
            config.payError({ msg: '支付失败' });
          }
        },
      );
    }

    if (typeof WeixinJSBridge === 'undefined') {
      if (document.addEventListener) {
        document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
      } else if (document.attachEvent) {
        document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
        document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
      }
    } else {
      onBridgeReady();
    }
  }
}

// 获取订单支付状态
async function getOrderStatus(opt) {
  return await request.get(`${SERVER_URL}/goodsOrder/payrecordDetail`, {
    params: opt,
  });
}

// 定时器轮询订单状态
function loopPayStatus(pid, cb) {
  timeout = setTimeout(async function () {
    let res = await getOrderStatus({ payrecordId: pid });
    console.log(res.data.payStatus === 'PAID');
    if (res.success) {
      switch (res.data.payStatus) {
        case 'WAITING':
          loopPayStatus(pid, cb);
          break;
        case 'CANCEL':
          config.payError(res);
          cb();
          break;
        case 'PAID':
          config.paySuccess(res.data);
          cb();
          break;
      }
    } else {
      loopPayStatus(pid, cb);
    }
  }, 1000);
}

function isQQBrowser() {
  // 是则返回版本号，否则返回false
  let match = window.navigator.userAgent.match(/MicroMessenger\/([0-9.]*)/);
  return match && match[1];
}

// 获取url上参数的属性
function setSearch(obj) {
  let search = '';
  for (const key in obj) {
    if (!obj[key]) continue;
    search += `&${key}=${obj[key]}`;
  }
  return search.replace('&', '?');
}



// WEBPACK FOOTER //
// ./src/utils/pay.js